<script>
    // @ts-nocheck

    export let responses;
    export let questionset_id;
    export let current_question_set_idx;
    export let is_last_question_set;
    export let show_responses = false;

    function showHideResponses(show_responses, responses) {
        let response_container = document.getElementById("sidebar");
        if (response_container) {
            if (show_responses) {
                response_container.innerHTML = JSON.stringify(
                    responses,
                    null,
                    4,
                );
            } else {
                response_container.innerHTML = "";
            }
        }
    }

    function populateQuestionSetTestResponses(
        e,
        questionset_id,
        go_to_next = false,
    ) {
        e.preventDefault();

        // for each question in this set...
        Object.keys(responses[questionset_id]).forEach((response) => {
            // ...find the available choices a user can make...
            let formOptions = document.querySelectorAll(`[name=${response}]`);

            // ...if there's more than one element associated with this item, then it's a multiple choice, likert, or percent
            if (formOptions.length > 1) {
                // ...so pick one at random
                responses[questionset_id][response] = parseFloat(
                    formOptions[~~(Math.random() * formOptions.length)].value,
                );
            } else if (document.querySelector(`#range_${response}`)) {
                // it's a percent
                responses[questionset_id][response] =
                    ~~(Math.random() * 101) / 10;
            } else {
                // it's a free text; special-case it.
                if (questionset_id == "usertags") {
                    responses["usertags"]["usertags_organization"] =
                        "TEST_organization";
                    responses["usertags"]["usertags_division"] =
                        "TEST_division";
                    responses["usertags"]["usertags_team"] = "TEST_team";
                }
            }
        });
        if (go_to_next && !is_last_question_set) {
            current_question_set_idx++;
        }
    }
    function populateAllTestResponses(e) {
        e.preventDefault();

        for (questionset_id in responses) {
            populateQuestionSetTestResponses(e, questionset_id);
        }
    }

    $: showHideResponses(show_responses, responses);
</script>

<div class="dev-shortcuts">
    <b>DEV shortcuts:</b>
    <label for="showResponses">
        <input
            type="checkbox"
            bind:checked={show_responses}
            id="showResponses"
        />show responses</label
    >
    <button
        on:click={(e) =>
            populateQuestionSetTestResponses(e, questionset_id, true)}
        >fill reponses {#if !is_last_question_set}and next{/if}</button
    >
    <button on:click={(e) => populateAllTestResponses(e)}
        >fill ALL reponses</button
    >
    skip to:
    <select bind:value={current_question_set_idx}>
        {#each Object.keys(responses) as questionset, idx}
            <option value={idx}>{questionset}</option>
        {/each}
    </select>
</div>

<style>
    .dev-shortcuts {
        width: fit-content;
        margin: 0.5em auto;
        padding: 0.5em 1em;
        text-align: center;
        background-color: palegoldenrod;
        border-radius: 1em;
    }
</style>
